import api from './api';

export const getTicket = (id) => api.get(`/tickets/${id}`);
export const getTicketByUuid = (uuid) => api.get(`/tickets/u/${uuid}`);
export const getTickets = (params) => api.get('/tickets', { params });
export const getTicketCounts = (params) => api.get('/tickets/counts', { params });
export const createTicket = (data) => api.post('/tickets', data);
export const updateTicket = (id, data) => api.put(`/tickets/${id}`, data);
export const deleteTicket = (id) => api.delete(`/tickets/${id}`);
export const deleteTicketsBulk = (ids) => api.delete('/tickets', { data: { ids } });
export const closeAllTickets = (data) => api.post('/tickets/closeAll', data);
export const getTicketLog = (ticketId, pageNumber = 1) =>
  api.get(`/tickets-log/${ticketId}`, { params: { pageNumber } });

// Motivos de fechamento de ticket
export const getTicketReasonOptions = () => api.get('/ticket-reasons/list');
export const getTicketReasons = (params) => api.get('/ticket-reasons', { params });
export const createTicketReason = (data) => api.post('/ticket-reasons', data);
export const updateTicketReason = (id, data) => api.put(`/ticket-reasons/${id}`, data);
export const deleteTicketReason = (id) => api.delete(`/ticket-reasons/${id}`);
export const linkTicketClient = (ticketId, clientId) =>
  api.put(`/tickets/${ticketId}/link-client`, { clientId });
export const getTicketKanban = (params) => api.get('/ticket/kanban', { params });
export const openTicketForContact = (contactId) =>
  api.post(`/tickets/open-for-contact/${contactId}`);
